import React from 'react';
import logo from '../../imgs/logo_komity.png';

export default function Terminos() {
    return (
        <div style={{ minHeight: '100vh', background: '#f8f9fa', fontFamily: 'system-ui, sans-serif' }}>
            <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <a href="/">
                    <img src={logo} alt="Komity" style={{ height: '32px' }} />
                </a>
            </div>
            <div style={{ maxWidth: '720px', margin: '0 auto', padding: '48px 24px' }}>
                <h1 style={{ fontWeight: 800, fontSize: '2rem', color: '#1a1a2e', marginBottom: '8px' }}>Términos y Condiciones</h1>
                <p style={{ color: '#6b7280', marginBottom: '40px' }}>Última actualización: agosto 2026</p>

                {[
                    {
                        titulo: '1. Aceptación',
                        texto: 'Al registrarte y usar Komity, aceptas estos Términos y Condiciones en su totalidad. Si no estás de acuerdo con alguna disposición, no uses el servicio.',
                    },
                    {
                        titulo: '2. Descripción del servicio',
                        texto: 'Komity es una plataforma de gestión gastronómica que ofrece punto de venta (TPV), catálogos digitales QR, gestión de pedidos y reportes para negocios del rubro gastronómico en Chile.',
                    },
                    {
                        titulo: '3. Cuenta de usuario',
                        texto: 'Eres responsable de mantener la confidencialidad de tus credenciales de acceso. Debes notificarnos inmediatamente ante cualquier uso no autorizado de tu cuenta. Cada cuenta corresponde a un negocio específico; no puedes ceder ni transferir tu cuenta sin autorización previa.',
                    },
                    {
                        titulo: '4. Plan de prueba gratuita',
                        texto: 'Los nuevos registros tienen acceso a 15 días de prueba gratuita sin necesidad de tarjeta de crédito. Al finalizar el período de prueba, debes contratar un plan de pago para continuar usando el servicio. No se realizan cobros automáticos sin tu autorización explícita.',
                    },
                    {
                        titulo: '5. Planes y pagos',
                        texto: 'Los planes tienen precios mensuales más IVA según el plan contratado. El pago debe realizarse mensualmente según la fecha de corte acordada. El incumplimiento de pago puede resultar en la suspensión del servicio después de un período de gracia de 7 días.',
                    },
                    {
                        titulo: '6. Propiedad intelectual',
                        texto: 'Komity y todos sus componentes (software, diseño, marca) son propiedad de sus desarrolladores. No puedes copiar, modificar, distribuir ni hacer ingeniería inversa del software.',
                    },
                    {
                        titulo: '7. Datos del negocio',
                        texto: 'Los datos que ingreses en la plataforma (productos, ventas, clientes) son de tu propiedad. Komity los usa únicamente para prestarte el servicio y no los vende a terceros. Tienes derecho a exportar y eliminar tus datos previa solicitud.',
                    },
                    {
                        titulo: '8. Limitación de responsabilidad',
                        texto: 'Komity se proporciona "tal cual". No garantizamos disponibilidad ininterrumpida. En ningún caso nuestra responsabilidad superará el monto pagado por el servicio en el último mes.',
                    },
                    {
                        titulo: '9. Modificaciones',
                        texto: 'Podemos modificar estos términos con 30 días de aviso previo por correo electrónico. El uso continuado del servicio después de ese plazo implica aceptación de los nuevos términos.',
                    },
                    {
                        titulo: '10. Jurisdicción',
                        texto: 'Estos términos se rigen por las leyes de la República de Chile. Cualquier disputa será sometida a los tribunales ordinarios de justicia de Santiago.',
                    },
                    {
                        titulo: '11. Contacto',
                        texto: 'Para consultas sobre estos términos: soporte@komity.cl',
                    },
                ].map((s) => (
                    <div key={s.titulo} style={{ marginBottom: '28px' }}>
                        <h2 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a1a2e', marginBottom: '8px' }}>{s.titulo}</h2>
                        <p style={{ color: '#4b5563', lineHeight: 1.7, margin: 0 }}>{s.texto}</p>
                    </div>
                ))}

                <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '24px', marginTop: '16px' }}>
                    <a href="/" style={{ color: '#7C3AED', fontWeight: 600, textDecoration: 'none', fontSize: '0.9rem' }}>← Volver al inicio</a>
                    {' · '}
                    <a href="/privacidad" style={{ color: '#7C3AED', fontWeight: 600, textDecoration: 'none', fontSize: '0.9rem' }}>Política de Privacidad</a>
                </div>
            </div>
        </div>
    );
}
